import { getStorage } from 'utils/storage'
import { APP_KEY } from 'constants/system'
import { USER_TOKEN_STORAGE_NAME, APPLICATION_KEY_STORAGE_NAME } from 'constants/storage'

type Headers = {
  [key: string]: string | boolean | undefined
}

async function getDefaultAPIHeader() {
  const appKeyValue = APP_KEY

  const userToken = getStorage(USER_TOKEN_STORAGE_NAME)

  const headers: Headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Access-Control-Allow-Headers': '*',
    [String(APPLICATION_KEY_STORAGE_NAME)]: appKeyValue,
    href: window.location.href,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    protocol: window.location.protocol,
  }

  if (userToken) {
    headers[String(USER_TOKEN_STORAGE_NAME)] = `Bearer ${userToken}`
  }

  return headers
}

export default getDefaultAPIHeader
